module.exports = __webpack_public_path__ + "static/media/icon_164.efd5df57.svg";